import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import { IoChevronDown } from 'react-icons/io5';

const MenuSubmenu = ({ text, Icon, isOpen, items, onClick, isMobile }) => {
    const location = useLocation();
    const isActive = items.some((item) => location.pathname === item.path);
    const [expanded, setExpanded] = useState(isActive);
    const canShowSubmenu = isOpen || isMobile;

    useEffect(() => {
        if (isActive) {
            setExpanded(true);
        }
    }, [isActive]);

    useEffect(() => {
        if (!canShowSubmenu) {
            setExpanded(isActive);
        }
    }, [canShowSubmenu, isActive]);

    const handleToggle = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!canShowSubmenu) {
            return;
        }
        setExpanded((prev) => !prev);
    };

    const showItems = expanded && canShowSubmenu;

    return (
        <div
            className={`menu-submenu-container ${isActive ? 'active-link' : ''} ${expanded ? 'menu-submenu-container--expanded' : ''}`}
        >
            <div className="menu-item-container menu-submenu-header">
                <button
                    type="button"
                    className="menu-submenu-trigger"
                    onClick={handleToggle}
                    aria-expanded={expanded}
                    aria-label={`${text}, submenú`}
                >
                    <div>
                        <Icon className="icon" />
                    </div>
                    <div className="span-container menu-submenu-label">
                        <span className={canShowSubmenu ? 'text' : 'text hidden'}>{text}</span>
                    </div>
                    {canShowSubmenu && (
                        <IoChevronDown
                            className={`menu-submenu-chevron ${expanded ? 'menu-submenu-chevron--open' : ''}`}
                            aria-hidden
                        />
                    )}
                </button>
            </div>
            <div className={`menu-submenu-items ${showItems ? 'menu-submenu-items--open' : ''}`}>
                {items.map((item) => (
                    <div
                        key={item.path}
                        className={
                            location.pathname === item.path
                                ? 'menu-item-container menu-submenu-item active-link'
                                : 'menu-item-container menu-submenu-item'
                        }
                    >
                        <Nav.Link as={Link} to={item.path} onClick={onClick}>
                            <span className="text menu-submenu-item-text">{item.text}</span>
                        </Nav.Link>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MenuSubmenu;
